import { shortDate, type InviteResult } from '../../lib/api'
import { Icon } from '../ui'

// The confirmation at the top of the vendor page after Send now, when the
// invitation went (lib/sentNote.ts says why it is here and not on a page of
// its own). It closes with one press and does not come back.

export function SentNote({ sent, onClose }: { sent: InviteResult; onClose: () => void }) {
  return (
    <div className="note ok vd-sent" role="status">
      <span className="vd-sent-icon" aria-hidden="true">
        <Icon name="check" size={18} />
      </span>
      <p>
        <strong>Sent to {sent.invitedEmail || 'the vendor'}.</strong> Questionnaire{' '}
        <span className="kit-mono">{sent.assessment?.reference}</span>
        {sent.assessment?.dueOn ? ' is due ' + shortDate(sent.assessment.dueOn) + '.' : '.'} The answers will show on this page and in
        My work when they come back.
      </p>
      <button type="button" className="ghost" onClick={onClose} aria-label="Close the confirmation">
        Close
      </button>
    </div>
  )
}
